'use client';

import { useState, useEffect, ReactNode } from 'react';
import { GoogleAnalytics } from '@next/third-parties/google';
import CookieConsent from '@/components/CookieContent';
import { useIsClient } from '@/hooks/useBrowser';


const GA_ID = process.env.NEXT_PUBLIC_GA_ID || '';

interface ProvidersProps {
  children: ReactNode;
}

export function Providers({ children }: ProvidersProps) {
    const isClient = useIsClient();
    const [consentGiven, setConsentGiven] = useState<boolean | null>(null);

  // Check for existing consent when component mounts
  useEffect(() => {
    if (!isClient) return;

    try {
      const analyticsConsent = localStorage.getItem('analyticsConsent');
      setConsentGiven(analyticsConsent === 'true');
    } catch (e) {
      // Handle any localStorage errors
      console.error('Error accessing localStorage:', e);
      setConsentGiven(false);
    }
  }, [isClient]);

  const handleConsentAccept = (): void => {
    if (!isClient) return;

    try {
      localStorage.setItem('analyticsConsent', 'true');
      setConsentGiven(true);
    } catch (e) {
      console.error('Error writing to localStorage:', e);
    }
  };

  // Only render GoogleAnalytics when we've checked consent and it's true
  const shouldShowAnalytics = consentGiven === true;

  return (
    <>
      {children}
      {shouldShowAnalytics && <GoogleAnalytics gaId={GA_ID} />}
      <CookieConsent onAccept={handleConsentAccept} />
    </>
  );
}